module.exports = __webpack_public_path__ + "img/female.815160e0.svg";